import React, { FunctionComponent } from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { ArrowLeft16Regular } from '@fluentui/react-icons';
import { useScopeBarStyles } from './styles';
import { getScopeFiltersOverflowChildComponent, getScopeBarLeftContent } from './helper';

export interface IScopeBarProps {
  children?: React.ReactNode;
  onBackClick?: (selectedEntity: any) => void;
  className?: string;
  selectedEntity?: any;
}

export const ScopeBar: FunctionComponent<IScopeBarProps> = (props) => {
  const {
    children,
    onBackClick,
    className,
    ...rest
  } = props;

  const {
    selectedEntity,
  } = rest;

  const styles = useScopeBarStyles();

  const filters = getScopeFiltersOverflowChildComponent(children);
  const leftAlignedChildContent = getScopeBarLeftContent(children);

  return (
    <div className={mergeClasses('scope-bar', styles.root, className)}>
      <div className={mergeClasses('scope-bar-left', styles.scopeBarLeft)}>
        {
          onBackClick
          && (
          <Button
            icon={<ArrowLeft16Regular />}
            appearance="subtle"
            onClick={() => onBackClick(selectedEntity)}
            className="scope-bar-back-button"
          />
          )
        }
        {
          leftAlignedChildContent && React.cloneElement(leftAlignedChildContent, { ...rest })
        }
      </div>

      {filters && React.cloneElement(filters, { ...rest })}
    </div>
  );
};

ScopeBar.defaultProps = {
  children: undefined,
  onBackClick: undefined,
  className: '',
  selectedEntity: undefined,
};
